module.exports = __webpack_public_path__ + "static/media/transaction-success.f5fb7aa3.png";